import { DangerIcon, useMobile } from "@cpj-ai/panel-npm-package";
import { Button, Card } from "@heroui/react";
import { OrgRegistrationStepEnum, useOrganizationProfileStore } from "@store/useOrganizationProfileStore";
import { useCallback } from "react";

const VerificationAlert = () => {
  const { setOrgRegistrationStep } = useOrganizationProfileStore();
  const isMobile = useMobile();

  const handlePressVerifyNow = useCallback(() => {
    setOrgRegistrationStep(OrgRegistrationStepEnum.selectVerificationMethod);
  }, [setOrgRegistrationStep]);

  const Container = isMobile ? "div" : Card;

  return (
    <Container className="flex flex-col gap-2.5 md:gap-0 md:flex-row justify-between p-3 bg-[#F7F8F4] md:bg-white">
      <div className="flex items-center gap-2">
        <DangerIcon className="w-6 h-6 min-w-6 min-h-6" viewBox="0 0 24 24" fill="#936316" />
        <p className="text-xs md:text-sm text-[#936316]">
          Your account information has not been verified. To use the site's services, first authenticate
        </p>
      </div>
      <Button
        className="rounded-xl text-xs h-auto md:h-10 md:text-base bg-[#F5A524] text-white md:w-64 py-2 md:py-5 self-end"
        onPress={handlePressVerifyNow}
      >
        Verify Now
      </Button>
    </Container>
  );
};

export default VerificationAlert;
